
import { twMerge } from 'tailwind-merge'
import definePrimitive from '../util/definePrimitive'

const Root = definePrimitive({
  name: 'PageBox',
  element: 'article',
  className: twMerge('typo-body rounded border-2 border-gray-200 bg-white p-6')
})

const Header = definePrimitive({
  name: 'PageBoxHeader',
  element: 'header',
  className: twMerge('mb-6 grid min-h-[2rem] grid-cols-[1fr_auto] [grid-template-areas:"title_after"]')
})

const Title = definePrimitive({
  name: 'PageBoxTitle',
  element: 'h1',
  className: twMerge('typo-heading flex items-center text-black [grid-area:title]')
})

export {
  Root,
  Header,
  Title
}
